import { Dispatch } from 'redux'
import { addParent } from '../apis/parentApi'
import { Action, ActionType, ParentDetailsType, errorMessageParentType } from '../types/parentType'

export const createParentDetails = (parentDetails: ParentDetailsType, isSubmit: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_PARENT_PENDING
    })
    try {
      parentDetails.customer.marketingCookieConsent = window?.Cookiebot?.consent?.marketing
      isSubmit && (await addParent(parentDetails))
      dispatch({
        type: ActionType.ADD_PARENT_SUCCESS,
        payload: { parentDetails, changed: isSubmit }
      })
    } catch (err) {
      dispatch({
        type: ActionType.ADD_PARENT_FAIL,
        payload: { errorMessage: err as errorMessageParentType | any }
      })
    }
  }
}

export const updateCouponCode = (couponCode: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_COUPON_CODE,
      payload: couponCode
    })
  }
}

export const updateChangedStatus = (status: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_CHANGE_STATUS,
      payload: status
    })
  }
}

export const updateParentEmail = (email: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_PARENT_EMAIL,
      payload: email
    })
  }
}

export const resetErrorMessageForParent = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET_ERROR_MESSAGE
    })
  }
}

export const resetParent = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET
    })
  }
}

export const resetLoadingStatus = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET_LOADING_STATUS
    })
  }
}
